import { ApolloCache } from '@apollo/client';
import { MediaCollectionsDocument, MediaCollectionsQuery } from '@graphql/generated';

export const evictMediaCollectionResponse = ({ cache, eventHandle }: { cache: ApolloCache<{}>; eventHandle: string }) => {
  const mediaCollectionsQueryBaseProps = {
    query: MediaCollectionsDocument,
    variables: { eventHandle },
  };
  const mediaCollectionsQueryCacheItem = cache.readQuery<MediaCollectionsQuery>(mediaCollectionsQueryBaseProps);

  if (mediaCollectionsQueryCacheItem?.eventByName) {
    // Evict mediaInfo field to refetch the thumbnail data
    cache.evict({ id: cache.identify(mediaCollectionsQueryCacheItem?.eventByName), fieldName: 'mediaInfo' });
    // Evict media field to refetch the all events media data
    cache.evict({ id: cache.identify(mediaCollectionsQueryCacheItem?.eventByName), fieldName: 'media' });

    // Garbage collection after all evictions
    cache.gc();
  }
};

export const evictMediaPhoto = ({ cache, mediaId }: { cache: ApolloCache<{}>; mediaId: string }) => {
  const cacheIdentifiedMediaItem = cache.identify({ __typename: 'MediaPhoto', id: mediaId });
  // Evict mediaPhoto item to remove the media from any collections
  cache.evict({ id: cacheIdentifiedMediaItem });
  cache.gc();
};
